import React from "react"
import { Form } from "react-bootstrap"
import { ConnectDragSource, ConnectDropTarget, DragSource, DragSourceConnector, DragSourceMonitor, DropTarget, DropTargetConnector, DropTargetMonitor } from "react-dnd"
import Checkbox from "../Checkbox"
import CustomizableColumn from "./CustomizableColumn"

export const DraggableTypeColumn = "Column"

interface DraggableColumnProps {
  column: CustomizableColumn
  moveColumn: (id: string, to: number) => void
  findColumn: (id: string) => { index: number }
  onVisibilityChange: (name: string, visible: boolean) => void
}

interface DragDropColumnProps extends DraggableColumnProps {
  connectDragSource: ConnectDragSource
  isDragging: boolean
  connectDropTarget: ConnectDropTarget
}

const DraggableColumnSource = {
  beginDrag(props: DraggableColumnProps) {
    return {
      id: props.column.name,
      originalIndex: props.findColumn(props.column.name).index
    }
  },
  endDrag(props: DraggableColumnProps, monitor: DragSourceMonitor) {
    const { id: droppedId, originalIndex } = monitor.getItem()
    if (!monitor.didDrop()) {
      props.moveColumn(droppedId, originalIndex)
    }
  }
}

const DraggableColumnCollect = (connect: DragSourceConnector, monitor: DragSourceMonitor) => ({
  connectDragSource: connect.dragSource(),
  isDragging: monitor.isDragging()
})

const DroppableColumnTarget = {
  canDrop: () => false,
  hover(props: DraggableColumnProps, monitor: DropTargetMonitor) {
    const { id: draggedId } = monitor.getItem()
    if (draggedId !== props.column.name) {
      const { index: overIndex } = props.findColumn(props.column.name)
      props.moveColumn(draggedId, overIndex)
    }
  }
}

const DroppableColumnCollect = (connect: DropTargetConnector) => ({ connectDropTarget: connect.dropTarget() })

class Column extends React.Component<DragDropColumnProps> {
  handleVisibilityChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    this.props.onVisibilityChange(e.target.name, e.target.checked)
  }

  render() {
    const { column, isDragging, connectDragSource, connectDropTarget } = this.props
    return connectDropTarget(connectDragSource(
      <div className={`customizedColumn${isDragging ? " hovered" : ""}`}>
        <Checkbox key={column.name} id={column.name} name={column.name}
          checked={column.visible || column.required}
          label={column.label || column.name}
          disabled={column.required}
          className={column.required ? "required" : ""}
          onChange={this.handleVisibilityChange} />
      </div>
    ))
  }
}

export default DropTarget(DraggableTypeColumn, DroppableColumnTarget, DroppableColumnCollect)(DragSource(DraggableTypeColumn, DraggableColumnSource, DraggableColumnCollect)(Column))
